import {getPaginatedGamesService} from "../../services/games/miniGames/paginatedGames.service";

export const PAGINATED_GAMES_PAGE_SIZE = 50;

export const getPaginatedGamesQueryKey = ({provider = "", class: classFilter = "", subclass = "", search = ""} = {}) => [
  "paginatedGames",
  provider,
  classFilter,
  subclass,
  search,
];

export const getPaginatedGamesQueryOptions = ({provider = "", class: classFilter = "", subclass = "", search = ""} = {}) => ({
  queryKey: getPaginatedGamesQueryKey({provider, class: classFilter, subclass, search}),
  queryFn: ({pageParam = 1}) =>
    getPaginatedGamesService({
      page: pageParam,
      limit: PAGINATED_GAMES_PAGE_SIZE,
      provider,
      class: classFilter,
      subclass,
      search,
    }),
  initialPageParam: 1,
  getNextPageParam: lastPage => {
    const pagination = lastPage?.data?.data?.pagination;
    if (!pagination) return undefined;
    const {page, total_pages} = pagination;
    return page < total_pages ? page + 1 : undefined;
  },
  staleTime: 60 * 1000,
});

export const prefetchPaginatedGames = (queryClient, filters) =>
  queryClient.prefetchInfiniteQuery(getPaginatedGamesQueryOptions(filters));
